import { Select, styled } from '@ltvco/refresh-lib/theme';

export const StyledSelect = styled(Select)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 'bold',
  color: theme.palette.primary.main,
}));
